export enum Project {
    smartparking = 'SmartParking',
    smartwaste = 'SmartWaste',
}
